var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.19834 1.97708C2.37513 1.97708 1.70592 2.74771 1.70592 3.69441C1.70592 4.6411 2.37513 5.41173 3.19834 5.41173H21.0486C21.8718 5.41173 22.5419 4.6411 22.5419 3.69441C22.5419 2.74771 21.8718 1.97708 21.0486 1.97708H3.19834ZM21.0485 6.46595H3.19819C1.86987 6.46595 0.789062 5.22302 0.789062 3.6944C0.789062 2.16578 1.86987 0.922852 3.19819 0.922852H21.0485C22.3777 0.922852 23.4585 2.16578 23.4585 3.6944C23.4585 5.22302 22.3777 6.46595 21.0485 6.46595Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.24837 10.0572C8.42516 10.0572 7.75596 10.8278 7.75596 11.7745C7.75596 12.7212 8.42516 13.4908 9.24837 13.4908H20.9585C21.7817 13.4908 22.4518 12.7212 22.4518 11.7745C22.4518 10.8278 21.7817 10.0572 20.9585 10.0572H9.24837ZM20.9586 14.545H9.24844C7.92012 14.545 6.83932 13.302 6.83932 11.7745C6.83932 10.2459 7.92012 9.00293 9.24844 9.00293H20.9586C22.2878 9.00293 23.3686 10.2459 23.3686 11.7745C23.3686 13.302 22.2878 14.545 20.9586 14.545Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2906 18.1373C13.4674 18.1373 12.7982 18.908 12.7982 19.8547C12.7982 20.8014 13.4674 21.5709 14.2906 21.5709H20.4564C21.2796 21.5709 21.9497 20.8014 21.9497 19.8547C21.9497 18.908 21.2796 18.1373 20.4564 18.1373H14.2906ZM20.4565 22.6252H14.2907C12.9623 22.6252 11.8815 21.3822 11.8815 19.8547C11.8815 18.326 12.9623 17.0831 14.2907 17.0831H20.4565C21.7857 17.0831 22.8665 18.326 22.8665 19.8547C22.8665 21.3822 21.7857 22.6252 20.4565 22.6252Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon);
export default __webpack_public_path__ + "static/media/menu-icon.434e8d8c1ba0f940e5f8fcfa645aac65.svg";
export { ForwardRef as ReactComponent };